import { MimaButton, MimaText, Modal, MimaDropdown } from "../../components";

import { Formik } from "formik";
import React from "react";

const CreatePayout = ({ closeModal, validationSchema, loading, onSubmit }) => {
  const getCurrentYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear;
  };

  const getYearsArray = () => {
    const currentYear = getCurrentYear();
    const years = [
      { value: String(currentYear - 1), key: String(currentYear - 1) },
      { value: String(currentYear), key: String(currentYear) },
      { value: String(currentYear + 1), key: String(currentYear + 1) },
    ];
    return years;
  };

  const yearsArray = getYearsArray();
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitle" align="center" mb={2}>
        Create Payout
      </MimaText>
      <Formik
        initialValues={{
          month: "",
          year: "",
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <>
            <MimaDropdown
              labelTitle="Year"
              placeholder="Select"
              name="year"
              value={values.year}
              id="year"
              onChange={(data) => {
                setFieldValue("year", data.key);
              }}
              data={yearsArray}
              touched={touched.year}
              error={errors.year}
            />
            <MimaDropdown
              labelTitle="Month"
              placeholder="Select"
              name="month"
              value={values.month}
              id="month"
              onChange={(data) => {
                setFieldValue("month", data.key);
              }}
              data={[
                {
                  value: "January",
                  key: 1,
                },
                {
                  value: "February",
                  key: 2,
                },
                {
                  value: "March",
                  key: 3,
                },
                {
                  value: "April",
                  key: 4,
                },
                {
                  value: "May",
                  key: 5,
                },
                {
                  value: "June",
                  key: 6,
                },
                {
                  value: "July",
                  key: 7,
                },
                {
                  value: "August",
                  key: 8,
                },
                {
                  value: "September",
                  key: 9,
                },
                {
                  value: "October",
                  key: 10,
                },
                {
                  value: "November",
                  key: 11,
                },
                {
                  value: "December",
                  key: 12,
                },
              ]}
              touched={touched.month}
              error={errors.month}
            />

            <MimaButton
              title="Continue"
              onClick={handleSubmit}
              type="submit"
              loading={loading}
              mt={2}
              width={38}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default CreatePayout;
